import { isFuture } from 'date-fns';

export const getTitleByDate = (date: Date) => {
  const isFutureDate = isFuture(date);

  return isFutureDate ? 'Консультация состоится' : 'Консультация прошла';
};
